import { orange } from '@/theme/colors'
import styled from 'styled-components'

export const IndicatorButton = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 0.35rem;
	padding: 0.25rem 0.625rem;
	background: #fef3ee;
	border: 1px solid #fddcc9;
	border-radius: 14px;
	color: ${orange};
	font-size: 0.7rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s;
	white-space: nowrap;

	svg {
		width: 12px;
		height: 12px;
		fill: currentColor;
	}

	&:hover {
		background: #fde8d8;
		border-color: ${orange};
	}
`
